import { api } from '@/api/client';
import { useQuery } from '@tanstack/react-query';

export interface TaxRateDto {
  id: string;
  tenantId: string;
  taxYear: number;
  taxType: string;
  rate: number;
  description?: string | undefined;
  legalRef?: string | undefined;
  validFrom: string;
  validTo: string;
}

export function useTaxRates(year: number) {
  return useQuery<TaxRateDto[]>({
    queryKey: ['payroll', 'tax-rates', year],
    queryFn: async () => {
      const res = await api.get<{ data: TaxRateDto[] }>(`/api/v1/payroll/tax-rates?year=${year}`);
      return res.data;
    },
    staleTime: 5 * 60_000,
  });
}
